<template>
  <div>
    <DataTable dataKey="id" :value="results" responsiveLayout="stack" breakpoint="640px">
      <Column header="Data de Vencimento" field="dueDate" :sortable="true">
        <template #body="{ data }">
          {{ data.dueDate ? $dayjs(data.dueDate).format('DD/MM/YYYY') : '-' }}
        </template>
      </Column>
      <Column header="Data do Pagamento" field="paidDate" :sortable="true">
        <template #body="{ data }">
          {{ data.paidDate ? $dayjs(data.paidDate).format('DD/MM/YYYY') : '-' }}
        </template>
      </Column>
      <Column header="Valor" field="billValue" :sortable="true">
        <template #body="{ data }">
          {{ data.billValue ? $toCurrency(data.billValue) : '-' }}
        </template>
      </Column>
      <Column header="Link de pagamento" field="observation">
        <template #body="{ data }">
          <span v-if="data.paymentLink">
            <a
              :href="formatPaymentLink(data.paymentLink)"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </span>
          <span v-else> - </span>
        </template>
      </Column>
      <Column header="Observações" field="observation">
        <template #body="{ data }">
          {{ data.observation || '-' }}
        </template>
      </Column>
    </DataTable>
    <Paginator
      :rows="query.pageSize"
      :totalRecords="pagination.total"
      @page="({ page }) => changeListPage({ page: page + 1 })"
    ></Paginator>
  </div>
</template>

<script>
import useApiList from '../../lib/useApiList';
import { InvoiceApi } from '../../services/api';

export default {
  name: 'InvoiceList',
  setup() {
    return useApiList(InvoiceApi, { pageSize: 12 });
  },
  async created() {
    await this.fetchList();
  },
  methods: {
    formatPaymentLink(link) {
      return link.startsWith('http') ? link : `https://${link}`;
    },
  },
};
</script>

<style>
</style>
